define('drops/documentPreviewer/documentPreviewer',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util'
], function ($, lq, Drop, Style, util) {
    'use strict';

    var filenameEndsWith = function(filename, suffixes) {
        if (!filename) return false;
        return _.some(suffixes, function (suffix) {
            return filename.toLowerCase().indexOf(suffix, filename.length - suffix.length) !== -1;
        });
    };

    function DocumentPreviewer(options) {
        Drop.call(this, $('<div/>'), options);
        Style.renderStyles(this);
    }

    Drop.extend(DocumentPreviewer, Drop);

    DocumentPreviewer.typeName = 'DocumentPreviewer';

    DocumentPreviewer.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    DocumentPreviewer.prototype.setValue = function (update) {
        var valueObj = util.convertListOfKeyValuesToObject(update.value);
        var fileUrl = this.getFileUrl(update, valueObj);

        this.$element.empty();
        if (!fileUrl) return;

        var fileSrcUrl = this.getFullFileUrl(fileUrl);

        if (this.isImageFile(fileUrl)) {
            this.renderImage(fileSrcUrl);
        } else if (this.isVideoFile(fileUrl)) {
            this.renderVideo(fileSrcUrl);
        } else {
            var embedSrcUrl = this.getEmbeddedUrl(fileUrl);
            this.renderFrame(embedSrcUrl);
        }
    };

    DocumentPreviewer.prototype.getFileUrl = function (update, valueObj) {
        if (!valueObj) return null;
        if ($.type(valueObj) === 'string') return valueObj;

        var v = update && update.value;
        return (v && (v.url || v.Url)) || null;
    };

    DocumentPreviewer.prototype.clearValue = function () {
        this.$element.empty();
    };

    DocumentPreviewer.prototype.renderImage = function (href) {
        this.$element.append(
            $('<img/>', { src: href }).css({
                display: 'block',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                margin: '0 auto'
            })
        );
    };

    DocumentPreviewer.prototype.renderVideo = function (href) {
        this.$element.append(
            $('<video/>', {
                src: href,
                controls: true
            }).css({
                display: 'block',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                margin: '0 auto'
            })
        );
    };

    DocumentPreviewer.prototype.renderFrame = function (href) {
        this.$element.append(
            $('<iframe/>', {
                src: href,
                width: '100%',
                height: '100%',
                frameborder: 0
            })
        );
    };

    DocumentPreviewer.prototype.getEmbeddedUrl = function (documentUrl) {
        var fullDocumentUrl = this.getFullFileUrl(documentUrl);

        if (this.isOfficeFile(documentUrl))
            return 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fullDocumentUrl);

        if (this.isPdfFile(documentUrl))
            return lq.getCdnUrl('drops/DocumentPreviewer/view/viewer.html?file=' + encodeURIComponent(fullDocumentUrl) + '&bust=v2023');

        return 'https://docs.google.com/viewer?url=' + encodeURIComponent(fullDocumentUrl) + '&embedded=true';
    };

    DocumentPreviewer.prototype.getFullFileUrl = function (fileUrl) {
        return lq.getFullUrl(lq.getTenantUrl('DynamicContent/DownloadFile?url=' + fileUrl + '&openInBrowser=true'));
    };

    DocumentPreviewer.prototype.isPdfFile = function (filename) {
        return filenameEndsWith(filename, ['.pdf']);
    };

    DocumentPreviewer.prototype.isOfficeFile = function (filename) {
        return filenameEndsWith(filename, ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']);
    };

    DocumentPreviewer.prototype.isImageFile = function (filename) {
        return filenameEndsWith(filename, ['.bmp', '.jpg', '.jpeg', '.png', '.gif']);
    };

    DocumentPreviewer.prototype.isVideoFile = function (filename) {
        return filenameEndsWith(filename, ['.avi', '.flv', '.m4v', '.mov', '.mp4', '.mpeg', '.mpg', '.ogv', '.webm', '.wmv']);
    };

    return DocumentPreviewer;
});
